export default "__VITE_ASSET__C2RR7MHV__"